<template>
    <toggle-button v-bind="$attrs" v-on="$listeners" :labels="labels" :sync="sync" :width="width" />
</template>
<script>
    import { ToggleButton } from 'vue-js-toggle-button';

    export default {
        components: {
            ToggleButton,
        },
        props: {
            labels: {
                type: [Boolean, Object],
                default: true,
                validator(value) {
                    return typeof value === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
                },
            },
            sync: {
                type: Boolean,
                default: true,
            },
            width: {
                type: Number,
                default: 45,
            },
        },
    };
</script>

<style>
    .vue-js-switch {
        margin-bottom: 0px !important;
        margin-right: 5px;
    }

    .v-switch-label {
        line-height: 2em !important;
    }
</style>
